export enum CopyModeOnItemsConflictEnum {
  SKIP_DUPLICATES = 'SKIP_DUPLICATES',
  REPLACE_ORIGINAL = 'REPLACE_ORIGINAL',
}
